import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Callback from '../views/Callback.vue'
import Logout from '../views/Logout.vue'
import TheTopBar from '../components/TheTopBar.vue'
import SilentRenew from '../views/SilentRenew.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    name: "login",
    components: {
      default: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "login" } },
  },
  {
    path: '/account',
    name: 'Account',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/Account.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "account" } },
    meta: { requiresAuth: true }
  },
  {
    path: '/favorites',
    name: 'Favorites',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/Favorites.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "fav" } },
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'Home',
    components: {
      default: Home,
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "home" } },
  },
  {
    path: '/search',
    name: 'Search',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/Search.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "search" } },
    meta: { requiresAuth: true }
  },
  {
    path: '/tutorial',
    name: 'Tutorial',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/Tutorial.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "tutorial" } },
    meta: { requiresAuth: true }
  },
  {
    path: '/contact',
    name: 'Contact',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "contact" } },
  },
  {
    path: '/links',
    name: 'Links',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/Links.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "links" } },
  },
  {
    path: '/about',
    name: 'About',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "about" } },
  },
  {
    path: "/callback",
    name: "Callback",
    components: {
      default: Callback,
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "callback" } },
  },
  {
    path: "/logout",
    name: "Logout",
    components: {
      default: Logout,
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "logout" } },
  },
  {
    path: "/silent-renew",
    name: "SilentRenew",
    component: SilentRenew,
  },
  {
    path: '/searchSubstances',
    name: 'SearchSubstances',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/SearchSubstances.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "SearchSubstances" } },
    meta: { requiresAuth: true }
  },
  {
    path: '/searchRules',
    name: 'SearchRules',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/SearchRules.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "SearchRules" } },
    meta: { requiresAuth: true }
  },
  {
    path: '/showSubstance',
    name: 'ShowSubstances',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/ShowSubstance.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "ShowSubstance" } },
    meta: { requiresAuth: true }
  },
  {
    path: '/searchuses',
    name: 'SearchUses',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/SearchUses.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "SearchUses" } },
    meta: { requiresAuth: true }
  },
  {
    path: '/searchmultirules',
    name: 'SearchMultiRules',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/SearchMultiRules.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "SearchMultiRules" } },
    meta: { requiresAuth: true }
  },
  {
    path: '/searchmultirulesResult',
    name: 'SearchMultiRulesResult',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/SearchMultiRulesResult.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "SearchMultiRulesResult" } },
    meta: { requiresAuth: true }
  },
  {
    path: '/export',
    name: 'Export',
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/Export.vue'),
      TheTopBar: TheTopBar,
    },
    props: { TheTopBar: { title: "Export" } },
    meta: { requiresAuth: true }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
